import styled from 'styled-components'

import { BREAKPOINT } from '../../design/breakpoint.constant'

const MapContainer = styled.div`
  display: none;

  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    display: block;
    width: 50%;
  }
`

export { MapContainer }
